/*
 * @Description:
 * @Author: 山淑兰
 * @Date: 2019-11-20 10:39:29
 * @LastEditTime: 2020-07-15 18:24:48
 * @LastEditors: 山淑兰
 */
/**
 * Created by VULCAN on 2018/8/8.
 */
import axios from 'axios'
import _ from 'lodash'
import Cookies from 'js-cookie'
import Utils from '../lib/utils'

// import Qs from "qs"

const _axios = axios.create({
	// headers:{'Content-Type': 'application/json'},
	// transformRequest: [
	//   data => {
	//     return Qs.stringify(data, { arrayFormat: "brackets" })
	//   }
	// ]
	// withCredentials: true
})

_axios.interceptors.request.use(
	(config) => {
		const {
			path
		} = window._VUE.$route
		if (path != "/liveInfo" && path != "/liveinfo") {
			let Authorization = ''
			try {
				if( path == '/elogin' || path == '/initPage'){
					Authorization = Cookies.get('wqExpertToken') || localStorage.getItem('wqExpertToken')
				}else{
					Authorization = Cookies.get('wqToken') || localStorage.getItem('wqToken')
				}
				if (Authorization) {
					config.headers = {
						Authorization,
					}
				}
			} catch (error) {
				alert('当前浏览器处于无痕模式,请使用标准浏览器!')
				console.error(error)
			}
		}
		return config
	},
	(error) => {
		return Promise.reject(error)
	}
)

_axios.interceptors.response.use(
	(res) => {
		let _data = null
		if (res.status === 200) {
			_data = res.data
			const {
				path
			} = window._VUE.$route
			console.log(path)
			if (path != "/liveInfo" && path != "/liveinfo") {
				if (_.isPlainObject(_data) && _data.Code) {
					const toUrl = encodeURIComponent(window.location.href)
					// console.log(toUrl.indexOf('ScanCheckin'))
					// if (path == '/ScanCheckin' || toUrl.indexOf('ScanCheckin') != -1 ) {
					//   localStorage.setItem('toSubmit', 0)
					// }else if( path == '/hotelOrder' || toUrl.indexOf('hotelOrder') != -1 ){
					//   localStorage.setItem('toSubmit', 1)
					// }else{
					//   localStorage.setItem('toSubmit', 2)
					// }
					switch (_data.Code) {
						// 会议未报名用户
						case 6003:
							if( path != '/elogin' && path != '/initPage'){
								Utils.redirect('/signup/meetingsignup', {
									toUrl
								})
							}
							break
							// 用户未验证手机号登录
						case 6001: {
							if (path != '/transition') {
								if( path == '/initPage'){
									Utils.redirect('/elogin', {
										toUrl
									})
								}else{
									Utils.redirect('/login', {
										toUrl
									})
								}
							}
							break
						}
						// 用户支付成功
						case 6008:
							if( path != '/elogin' && path != '/initPage'){
								Utils.redirect('/signup/signupinfo')
							}
							break
							// 8001微信未授权登录;  2001未获取到数据标识
						case 8001:
							if (path != '/transition') {
								Utils.redirect('/transition', {
									toUrl
								})
							}
							break
						case 2001:
							window._VUE.$dialog
								.alert({
									title: '提示',
									message: _data.Msg,
								})
								.then(() => {
									if (path != "/guest/scheduleList") {
										window.wx.closeWindow()
									} else {
										console.log('关闭')
									}
								})
							break
							// 本次会议已报名用户
						case 6004:
							if (path == '/signup/meetingsignup' && _data.signUp_Set.jump_link) {
								console.log(_data.signUp_Set.jump_link)
							} else if (path != '/signup/addPersonnel') {
								Utils.redirect('/signup/signupinfo')
							}
							break
							//  6002，用户已登录并验证了手机号
						case 6002:
							if (path != '/transition') {
								if (toUrl) {
									window.location.href = decodeURIComponent(toUrl)
								} else {
									Utils.redirect('/signup/meetingsignup')
								}
							}
							break
							//1010 待支付
						case 1010:
							Utils.redirect('/pay')
							break
							// 1000调用成功标识，全局统一；
						case 1000:
							break
						case 3001:
							break
						case 7001:
							break
						case 7002:
							break
							// 内部系统错误，或标识数据验证失败
						case 3333:
							if( path == '/initPage'){
								Utils.redirect('/elogin')
								return
							}else{
								window._VUE.$notify({
									message: _data.Msg,
									type: 'danger',
								})
							}
							break
						default:
							window._VUE.$notify({
								message: _data.Msg,
								type: 'danger',
								duration: 20000,
							})
					}
				}
			}
		}
		return _data
	},
	(err) => {
		console.log(err)
		const toUrl = encodeURIComponent(window.location.href)
		const {
			path
		} = window._VUE.$route
		switch (err.response.status) {
			case 400:
				break
			case 401: {
				if( path == '/initPage'){
					Utils.redirect('/elogin')
				}else{
					Utils.redirect('/transition', {
						toUrl
					})
				}
				break
			}
			case 405:
			case 500:
			default:
				// if (err.response.data && err.response.data.message) {
				//   window._VUE.$message.error(err.response.data.message)
				// } else {
				//   window._VUE.$message.error('服务器错误')
				// }
				break
		}
		return err.response
	}
)

export default _axios
